import { render, staticRenderFns } from "./ObjectsSidebar.vue?vue&type=template&id=6936667c&scoped=true"
import script from "./ObjectsSidebar.vue?vue&type=script&lang=ts"
export * from "./ObjectsSidebar.vue?vue&type=script&lang=ts"
import style0 from "./ObjectsSidebar.vue?vue&type=style&index=0&id=6936667c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6936667c",
  null
  
)

export default component.exports